<template>
  <div class="card">
    <div class="bg-blue-light p-1">
      <TitleButton
          :showBtn="false"
          :showAddNew="false"
          title="Leave Balance Import"
      >
        <template #extra-btn>
          <a
              download
              href="/file/import-leave-balance.xlsx"
              class="btn btn-outline-secondary waves-effect waves-float waves-light"
          >Download Sample</a>
        </template>
      </TitleButton>
      <input type="file" class="d-none" ref="uploader" @change="handleFileUpload">
    </div>

    <div class="row p-2">
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Leave Policy</label>
        <v-select
            placeholder="Select Leave Policy"
            v-model="leavePolicyId"
            :options="leavePolicy"
            label="name"
            :reduce="name => name.id"
        />
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Date From</label>
        <input type="date" class="form-control" v-model="dateFrom">
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-3">
        <label class="col-form-label">Date To</label>
        <input type="date" class="form-control" v-model="dateTo">
      </div>
      <div class="col-12 col-sm-6 col-md-4 col-lg-2 mt-auto">
        <button @click="onClickBrowse" class="btn btn-primary waves-effect waves-float waves-light">
          Browse
        </button>
      </div>
    </div>

    <div class="p-2">
      <div v-for="(item, index) in csvRow" :key="index">
        <div @click="goToUpload(item.id)" class="py-1 bg-black-light rounded-8 mb-2 d-flex justify-content-between align-items-center cursor-pointer">
          <span class="px-1">id: {{ item.id }} Dataset: {{ item.batch }}</span>
          <div class="d-flex gap-1 px-1">
            <span class="cursor-pointer text-danger" @click.stop="deleteRow(item.id)"><i class="fas fa-trash"></i></span>
          </div>
        </div>
      </div>
    </div>

    <GlobalLoader/>
  </div>
</template>

<script setup>
import TitleButton from '@/components/atom/TitleButton.vue'
import GlobalLoader from '@/components/atom/GlobalLoader.vue'
import {inject, onMounted, ref} from 'vue'
import {useRoute, useRouter} from 'vue-router'
import handleInventory from '@/services/modules/inventory'
import handleHrPayroll from '@/services/modules/hrPayroll/hrPayroll'

const route = useRoute()
const router = useRouter()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const {uploadLeaveBalanceSheet, fetchLeavePolicyList} = handleHrPayroll()
const {fetchCsvRow, deleteCsvRow} = handleInventory()

const uploader = ref(null)
const csvRow = ref([])
const leavePolicy = ref([])
const leavePolicyId = ref(null)
const dateFrom = ref('')
const dateTo = ref('')

const getQuery = () => {
  return `?company_id=${route.params.companyId}`
}

const goToUpload = (id) => {
  const query = Object.assign({}, route.query)
  query.rowId = id
  router.push({name: 'leave-balance-import', params: route.params, query})
}

const getCsvRow = () => {
  const query = getQuery() + '&type=leave_balance'
  fetchCsvRow(query).then((res) => {
    if (!res.status) return
    csvRow.value = res.data
  })
}

const getLeavePolicy = () => {
  const query = getQuery() + '&is_all=true&status=active'
  fetchLeavePolicyList(query).then((res) => {
    if (!res.status) return
    leavePolicy.value = res.data
  })
}

const deleteRow = (id) => {
  if (!confirm('Are you sure you want to delete this row?')) return
  const query = getQuery() + '&type=leave_balance'
  deleteCsvRow(query, id).then((res) => {
    if (!res.status) return showError(res.message)
    csvRow.value = []
    getCsvRow()
    showSuccess(res.message)
  })
}

const onClickBrowse = () => {
  if (!leavePolicyId.value) return showError('Please select leave policy')
  if (!dateFrom.value) return showError('Please select date from')
  if (!dateTo.value) return showError('Please select date to')
  uploader.value.click()
}

const handleFileUpload = (event) => {
  const fd = new FormData()
  fd.append('company_id', route.params.companyId)
  fd.append('sheet', event.target.files[0])
  fd.append('leave_policy_id', leavePolicyId.value)
  fd.append('date_from', dateFrom.value)
  fd.append('date_to', dateTo.value)

  uploadLeaveBalanceSheet(fd).then((res) => {
    if (!res.status) return showError(res.message)
    showSuccess(res.message)
    getCsvRow()
  }).finally(() => {
    uploader.value.value = ''
  })
}

onMounted(() => {
  getLeavePolicy()
  getCsvRow()
})
</script>
